module.exports = __webpack_public_path__ + "jose_police_neto--2a652884.jpg";


//////////////////
// WEBPACK FOOTER
// ./_source/img/candidatos/jose_police_neto.jpg
// module id = 166
// module chunks = 0